import classNames from 'classnames';
import React, { FC } from 'react';
import benefitsImage from '../../../assets/images/onboarding/benefits.svg';
import { BenefitsPanel } from '../../../components/onboarding/BenefitsPanel/BenefitsPanel';
import { CenteredPageContainer } from '../../../components/onboarding/CenteredPageContainer/CenteredPageContainer';
import { SplitContainer } from '../../../components/onboarding/SplitContainer/SplitContainer';
import { BookCallStep } from '../../../components/onboarding/steps/BookCallStep/BookCallStep';
import './AuthContainer.scss';

export const AuthContainer: FC<{
  unauthorized: boolean;
  signup?: boolean;
  className?: string;
}> = ({ children, unauthorized, className, signup }) => {
  return (
    <CenteredPageContainer classes={classNames('authContainer', className)}>
      {unauthorized ? (
        <BookCallStep />
      ) : (
        <>
          <SplitContainer
            left={children}
            right={
              <BenefitsPanel
                splashImage={benefitsImage}
                title={
                  signup
                    ? BENEFITS_PANEL_SIGNUP_TITLE
                    : BENEFITS_PANEL_LOGIN_TITLE
                }
              />
            }
          />
          <div className="legalFooter">
            By continuing, you acknowledge that you have read, and agree to our{' '}
            <a
              href="https://dashworks.ai/terms-of-service"
              rel="noreferrer"
              target="_blank"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href="https://dashworks.ai/privacy-policy"
              rel="noreferrer"
              target="_blank"
            >
              Privacy Policy.
            </a>
          </div>
        </>
      )}
    </CenteredPageContainer>
  );
};
